import React from 'react';

// StatusModal component displays a modal for status confirmation
const StatusModal = ({ show, nextStatus, onYesClick, onNoClick }) => {
  // Handle Yes button click
  const handleYesClick = () => {
    // Always call the submit / API handler
    if (onYesClick) onYesClick();

    // Extra action only for Moving to Patient Location
    if (nextStatus === "Moving to Patient Location") {
      const userName = sessionStorage.getItem("User_Name") || "Guest";
      window.open(`/ems-team.html?name=${encodeURIComponent(userName)}`, "_blank");
    }
  };

  // Render modal conditionally based on show and nextStatus props
  return (
    show && nextStatus && (
      <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center p-4">
              <h2>{nextStatus}</h2>
              <div className="mt-4">
              {nextStatus === "Acknowledgment is required before proceeding to the next status." ? (
                <button className="btn btn-primary" onClick={onNoClick}>
                  OK
                </button>
              ) : (
                <>
                  <button className="btn btn-primary me-2" onClick={handleYesClick}>
                    Yes
                  </button>
                  <button className="btn btn-secondary" onClick={onNoClick}>
                    No
                  </button>
                </>
              )}
            </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

// Export the StatusModal component
export default StatusModal;